import { PureComponent } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { appointmentActions, appointmentDraftSelectors, appointmentSelectors } from '~/api';
import { apiCallFinished } from '../loading-spinner';
import { restoreAppointmentData } from '~/routes/helpers';

export const withPreloadAppointment = (Content) =>
  class ComponentWithPreloadAppointment extends PureComponent {
    state = {
      isLoaded: false,
    };

    static propTypes = {
      appointment: PropTypes.shape({}),
      storeId: PropTypes.string.isRequired,
      dispatchGetAppointment: PropTypes.func.isRequired,
      dispatchRestoreAppointment: PropTypes.func.isRequired,
      dispatchApiCallFinished: PropTypes.func.isRequired,
    };

    static defaultProps = {
      appointment: null,
    };

    componentDidMount() {
      const {
        appointment,
        storeId,

        dispatchGetAppointment,
        dispatchRestoreAppointment,
        dispatchApiCallFinished,
      } = this.props;

      if (!appointment) {
        dispatchApiCallFinished(false);
        dispatchGetAppointment(storeId, [404])
          .then(() =>
            dispatchRestoreAppointment(false, {}).then(() => {
              dispatchApiCallFinished(true);
              this.setState({
                isLoaded: true,
              });
            }),
          )
          .catch(() => {
            this.setState(() => ({
              isLoaded: true,
            }));
          });
      } else {
        this.setState(() => ({
          isLoaded: true,
        }));
      }
    }

    render() {
      const { isLoaded } = this.state;

      return isLoaded && <Content {...this.props} />;
    }
  };

export const mapStateToProps = (state) => ({
  appointment: appointmentSelectors.selectAppointment(state),
  storeId: appointmentDraftSelectors.selectShop(state).id,
});

const mapDispatchToProps = {
  dispatchGetAppointment: appointmentActions.getAppointment,
  dispatchRestoreAppointment: restoreAppointmentData,
  dispatchApiCallFinished: apiCallFinished,
};
export const ConnectedWithPreloadAppointment = (Component) =>
  withRouter(connect(mapStateToProps, mapDispatchToProps)(withPreloadAppointment(Component)));
